import React, { useState } from 'react';

const MapFrame = ({ url, customData, interactive = true, className = "" }) => {
    const [hoveredZone, setHoveredZone] = useState(null);

    if (!url) return (
        <div className="w-full h-full bg-neutral-200 dark:bg-neutral-800 animate-pulse flex items-center justify-center">
            <span className="text-[10px] font-black uppercase tracking-widest opacity-20 italic">Initialising Radar...</span>
        </div>
    );

    const activeZone = customData?.zones?.find(z => z.id === hoveredZone);

    return (
        <div className={`relative w-full h-full overflow-hidden ${className}`}>
            {/* --- LAYER 1: THE MAP CANVAS --- */}
            <iframe
                src={url}
                title="Service Area Map"
                className={`
                    w-full h-full transition-all duration-700
                    grayscale-[0.4] contrast-[1.1] 
                    dark:invert dark:hue-rotate-180 dark:brightness-90 
                    ${!interactive ? 'pointer-events-none' : 'pointer-events-auto'}
                `}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
            />

            {/* --- LAYER 2: THE LOCATION MARKERS (SVG) --- */}
            {customData?.zones && (
                <div className="absolute inset-0 pointer-events-none">
                    <svg className="w-full h-full pointer-events-auto" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
                        {customData.zones.map(pin => (
                            <g
                                key={pin.id}
                                className="cursor-pointer pointer-events-auto group/pin"
                                onMouseEnter={() => setHoveredZone(pin.id)}
                                onMouseLeave={() => setHoveredZone(null)}
                            >
                                {/* Pulsing Ring */}
                                <circle cx={pin.x} cy={pin.y} r="3" className="fill-primary-500/30 animate-pulse" />
                                {/* Main Pin */}
                                <circle
                                    cx={pin.x}
                                    cy={pin.y}
                                    r="1.2"
                                    className="fill-primary-500 stroke-white dark:stroke-neutral-900 stroke-[0.4px] shadow-2xl transition-all group-hover/pin:r-2"
                                />
                            </g>
                        ))}
                    </svg>
                </div>
            )}

            {/* --- LAYER 3: FLOATING TOOLTIP --- */}
            <div className={`
                absolute bottom-6 left-6 z-20 transition-all duration-500 
                ${activeZone ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}
            `}>
                <div className="bg-white/90 dark:bg-neutral-900/90 backdrop-blur-xl p-4 rounded-3xl shadow-2xl border border-neutral-200/50 dark:border-white/10 min-w-[180px]">
                    <h4 className="text-sm font-black text-primary-900 dark:text-white uppercase er">
                        {activeZone?.label}
                    </h4>
                    <p className="text-[10px] font-bold text-neutral-500 uppercase tracking-widest">
                        {activeZone?.info}
                    </p>
                </div>
            </div>

            {/* --- AESTHETIC OVERLAYS --- */}
            <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.02)_50%),linear-gradient(90deg,rgba(255,0,0,0.01),rgba(0,255,0,0.01),rgba(0,0,255,0.01))] bg-[length:100%_2px,3px_100%] opacity-10" />
            <div className="absolute inset-0 pointer-events-none shadow-[inset_0_0_100px_rgba(0,0,0,0.1)] dark:shadow-[inset_0_0_100px_rgba(0,0,0,0.3)]" />
        </div>
    );
};

export default MapFrame;